import React from 'react';

const Chat: React.FC = () => (
  <svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.498 0.347656C5.98405 0.347656 1.49805 4.38466 1.49805 9.34766C1.49805 11.0827 2.03905 12.7397 3.07105 14.1837C0.498047 18.3477 0.498047 18.3477 0.498047 18.3477C0.498047 18.3477 7.08105 18.3477 11.498 18.3477C17.012 18.3477 21.498 14.3107 21.498 9.34766C21.498 4.38466 17.012 0.347656 11.498 0.347656Z"
      fill="black"
    />
  </svg>
);

export default Chat;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/components/TechCoachCTA/icons/Chat.tsx